module.exports = "/fonts/line-awesome.eot?3f85d8035b4ccd91d2a1808dd22b7684";